export default __webpack_public_path__ + "static/media/add-playlist.5ca91948.svg";